import React, { FC } from 'react'

export const MailingCampaigns: FC = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.6 7A2.6 2.6 0 0 0 4 9.6v17a2.6 2.6 0 0 0 2.6 2.6h17a.6.6 0 1 0 0-1.2h-17a1.4 1.4 0 0 1-1.4-1.4v-17a1.4 1.4 0 0 1 1.4-1.4h26A1.4 1.4 0 0 1 34 9.6v9a.6.6 0 1 0 1.2 0v-9A2.6 2.6 0 0 0 32.6 7h-26Z"
      fill="#026AE1"
    />
    <path
      d="M8.004 10.676a.6.6 0 0 0-.755.932l8.155 6.606-8.165 6.897a.6.6 0 0 0 .775.917l8.34-7.045 1.904 1.542a2.32 2.32 0 0 0 2.942-.018l10.72-8.903a.6.6 0 1 0-.768-.923l-10.718 8.903a1.12 1.12 0 0 1-1.421.009l-2.188-1.773-.01-.012a.598.598 0 0 0-.19-.15l-8.62-6.982ZM34.871 20.44c.877-.103 1.449.897.914 1.6l-7.678 10.094c-.555.73-1.716.39-1.792-.523l-.28-3.369a.6.6 0 1 1 1.196-.099l.237 2.85 7.077-9.305-11.719 1.394 3.578 2.605 4.84-2.972a.6.6 0 0 1 .627 1.022l-4.953 3.042a1 1 0 0 1-1.112-.043l-4.098-2.984c-.735-.535-.433-1.694.47-1.801l12.693-1.51Z"
      fill="#026AE1"
    />
  </svg>
)
